import { render, staticRenderFns } from "./onlinecourses.vue?vue&type=template&id=3b3b9b19&scoped=true&"
import script from "./onlinecourses.vue?vue&type=script&lang=js&"
export * from "./onlinecourses.vue?vue&type=script&lang=js&"
import style0 from "./onlinecourses.vue?vue&type=style&index=0&id=3b3b9b19&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3b9b19",
  null
  
)

export default component.exports